export const memberTypes = [
  {
    id: "personal",
    title: "個人會員",
    subtitle: "Individual Membership",
    description: "適合對 AI 應用有興趣的專業人士、研究者、學生及相關領域從業人員。",
    annualFee: "2,000",
    features: [
      { label: "活動報名費", value: "9 折優惠" },
      { label: "講座與工作坊", value: "不限次數免費參加" },
      { label: "產業報告", value: "年度下載權限" },
      { label: "社群交流", value: "會員專屬社群" },
    ],
    badgeColor: "bg-navy-700",
    cardBg: "bg-white",
  },
  {
    id: "group",
    title: "團體會員",
    subtitle: "Group Membership",
    description: "適合學術單位、研究機構、非營利組織及中小企業，享有團體專屬福利。",
    annualFee: "5,000",
    features: [
      { label: "活動報名費", value: "8 折優惠" },
      { label: "講座與工作坊", value: "3 個名額免費" },
      { label: "產業報告", value: "季度優先下載" },
      { label: "合作曝光", value: "活動品牌露出" },
    ],
    badgeColor: "bg-navy-800",
    cardBg: "bg-navy-950",
    highlight: true,
  },
  {
    id: "corporate",
    title: "企業會員",
    subtitle: "Corporate Membership",
    description: "適合大型企業與產業領導品牌，享有最高階的專屬服務與合作機會。",
    annualFee: "20,000",
    features: [
      { label: "活動報名費", value: "7 折優惠" },
      { label: "講座與工作坊", value: "5 個名額免費" },
      { label: "產業報告", value: "獨家研究內容" },
      { label: "合作曝光", value: "官網 + 活動品牌露出" },
    ],
    badgeColor: "bg-navy-900",
    cardBg: "bg-white",
  },
];

export const benefits = [
  {
    icon: "ri-calendar-check-line",
    title: "活動優先報名",
    description: "論壇、研討會、工作坊等活動享有優先報名權與專屬折扣，不錯過任何產業趨勢。",
  },
  {
    icon: "ri-presentation-line",
    title: "會員限定講座",
    description: "專為會員規劃的線上線下講座，邀請產業領袖與技術專家分享第一手經驗。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "產業報告與刊物",
    description: "定期取得 AI 產業趨勢報告、應用案例研究、白皮書與電子會刊。",
  },
  {
    icon: "ri-team-line",
    title: "專屬交流社群",
    description: "進入會員專屬社群平台，與同業專家交流、媒合資源、拓展人脈。",
  },
  {
    icon: "ri-vip-crown-line",
    title: "合作曝光機會",
    description: "團體與企業會員可於協會活動、官網與社群中獲得品牌露出與合作推薦。",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "人才媒合與培育",
    description: "參與人才培育計畫，取得優秀 AI 人才推薦與企業媒合服務。",
  },
];

export const applicationProcess = [
  {
    step: "01",
    title: "線上填寫申請表",
    description: "選擇會員類型並填寫基本資料，提交入會申請。",
  },
  {
    step: "02",
    title: "資料審核",
    description: "秘書處將於 5 個工作天內完成資格審核。",
  },
  {
    step: "03",
    title: "繳交會費",
    description: "收到通知後，依指示繳交當年度會費。",
  },
  {
    step: "04",
    title: "正式入會",
    description: "完成繳費後，取得會員資格與專屬權益。",
  },
];

/** 邀請制（預設）時顯示的入會流程；開放線上申請時改用 applicationProcess。 */
export const inviteProcess = [
  {
    step: "01",
    title: "推薦或邀請",
    description: "由理監事、現有會員推薦，或由秘書處主動邀請；也歡迎來信自我推薦。",
  },
  {
    step: "02",
    title: "資格確認",
    description: "秘書處與您聯繫，確認會員類型、基本資料與參與方向。",
  },
  {
    step: "03",
    title: "繳交會費",
    description: "收到通知後，依指示繳交當年度會費。",
  },
  {
    step: "04",
    title: "正式入會",
    description: "完成繳費後，取得會員資格與專屬權益。",
  },
];

export const faqItems = [
  {
    q: "會員資格審核需要多久？",
    a: "秘書處將於收到申請後 5 個工作天內完成審核，並以 Email 通知審核結果。",
  },
  {
    q: "會費可以開立發票嗎？",
    a: "可以，TAIAA 為依法立案之社團法人，可開立收據及發票。",
  },
  {
    q: "企業會員可以指定多位聯絡人嗎？",
    a: "可以，企業會員最多可設定 5 位聯絡人，共同享有會員權益。",
  },
  {
    q: "入會後可以隨時退會嗎？",
    a: "會員可依章程規定提出退會申請，已繳納之年度會費不予退還。",
  },
];